/***************************************************************************************/ 
 /* This file is generated. Do not edit by hand unless you 100% know what you're doing.. */ 
 /***************************************************************************************/ 
 
export enum GroupVarKey { 
    Name = "Name",
    WebsiteURL = "WebsiteURL",

}